namespace Gordic.Epk.WebControls {

    const { gcontent } = Decorators;

    @gcontent
    export class GEpkTestCnt extends GContentBase {

        public onContentReady() {
            this.createForm();
            this.createActions();
        }

        private createForm() {

            const Form = new Gordic.Forms.Form({ name: "formTest" });
            const form = $("<div>").appendTo(this.element);

            Form
                .addRow({
                    required: true,
                    label: "Šablona podpisu, Požadavek"
                })
                .addField("gselectbox", Gordic.Prefabs.Select.wflsdpo(), {
                    name: "IxsDpo",
                    model: "model.IxsDpo = value.ixs_dpo"
                })


            //const data: Gordic.Wfl.Interface.EpkSupervisorEnum[] = [
            //    Gordic.Wfl.Interface.EpkSupervisorEnum.Ne,
            //    Gordic.Wfl.Interface.EpkSupervisorEnum.AnoCelyUrad,
            //    Gordic.Wfl.Interface.EpkSupervisorEnum.AnoSpisUzel,
            //    Gordic.Wfl.Interface.EpkSupervisorEnum.AnoPodrizeneSpisUzel
            //];

            //const view = new Data.View<Gordic.Wfl.Interface.EpkSupervisorEnum>(data);

            //Form
            //    .addRow("jres:32000593") //RC 32000593 : Vlastnictví
            //    .addField("gselectbox", {
            //        name: "supervisor",
            //        dropdown: true,
            //        emptyValue: null,
            //        initialValue: Gordic.Wfl.Interface.EpkSupervisorEnum.AnoCelyUrad,
            //        data: view,
            //        itemTemplate: (value) => {
            //            if (value === Gordic.Wfl.Interface.EpkSupervisorEnum.AnoCelyUrad)
            //                return "jres:32000589"; //RC 32000589 : Celý úřad
            //            else if (value === Gordic.Wfl.Interface.EpkSupervisorEnum.AnoSpisUzel)
            //                return "jres:32000590"; //RC 32000590 : Aktuální spisový uzel
            //            else if (value === Gordic.Wfl.Interface.EpkSupervisorEnum.AnoPodrizeneSpisUzel)
            //                return "jres:32000592"; //RC 32000592 : Podřízené spisové uzly
            //            else
            //                return "jres:32000591"; //RC 32000591 : Funkční místo
            //        },
            //    })


            form.gform("createFrom", Form);

            // DEMOAW40A03Q
            // 0000Aw40000I (neurčeno)

            //this.findFields().gfield("model", "apply", { ixsDpo: "0000Aw40000I", nazev: "Neurčeno" }, { setFlags: { valid: false } });


            const Dto = {
                IxsDpo: "0000AW40000I"  // neurčeno
            };

            this.element.findFields().gfield("model", "apply", Dto, { initialValues: true });


        }

        private createActions() {

            var actGenRqInternal = new GAction({
                name: "actGenRqInternal",
                caption: "GenRqInternal",
                run: () => {

                    const idFlash = "GenRqInternalFlashId";
                    this.hideFlash(idFlash);

                    this.call("Generate")
                        .then((state) => {
                            if (state === true) {
                                this.showFlash({
                                    content: "jres:32001069", //RC 32001069 : Internal generation of requests has been successfully completed
                                    state: "info",
                                    id: idFlash
                                });
                            }
                        });
                }
            });

            this.actions.add(actGenRqInternal);

        }

    }

}